import { FormProvider } from "react-hook-form";
import { Button } from "primereact/button";
import { IUserFormProps } from "./User.model";
import { FormRow } from "../../components/FormRow";
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { userRoleService } from "../../service/UserRole/userRole.service";
import { useEffect, useState } from "react";
import { STATUS_OPTIONS } from "../../library/utilities/constants/constant";

const UserForm = ({ methods, onSubmit, isEdit }: IUserFormProps) => {
  const [roleOptions, setRoleOptions] = useState<
    { label: string; value: number }[]
  >([]);

  const loadUserRoles = async () => {
    const res = await userRoleService.getAll();
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    const options = sortedData.map((role) => ({
      label: role.name,
      value: role.id,
    }));
    setRoleOptions(options);
  };

  useEffect(() => {
    loadUserRoles();
  }, []);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="p-fluid">
        <FormRow label="Username *" name="username">
          <CustomInput name="username" />
        </FormRow>

        <FormRow label="First Name *" name="first_name">
          <CustomInput name="first_name" />
        </FormRow>

        <FormRow label="Last Name *" name="last_name">
          <CustomInput name="last_name" />
        </FormRow>

        <FormRow label="Email *" name="email">
          <CustomInput name="email" type="email" />
        </FormRow>

        {!isEdit && (
          <FormRow label="Password *" name="password">
            <CustomInput name="password" type="password" />
          </FormRow>
        )}

        <FormRow label="Role *" name="group_id">
          <CustomSelect
            name="group_id"
            options={roleOptions}
            placeholder="Select role"
          />
        </FormRow>

        <FormRow label="Status *" name="is_active">
          <CustomSelect
            name="is_active"
            options={STATUS_OPTIONS}
            placeholder="Select status"
          />
        </FormRow>

        {/* Submit */}
        <div className="mt-4 flex justify-content-end">
          <Button
            label={isEdit ? "Update User" : "Create User"}
            type="submit"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default UserForm;
